var _path, _rect, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 33.056,
    y: 461.98,
    style: {
      fill: "#CCCCCC"
    },
    width: 63.2,
    height: 24.16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.744,
    y: 461.98,
    style: {
      fill: "#CCCCCC"
    },
    width: 63.2,
    height: 24.16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M498.432,461.98H13.568C6.104,461.98,0,455.876,0,448.412v-118.08c0-7.464,6.104-13.568,13.568-13.568h484.864 c7.464,0,13.568,6.104,13.568,13.568v118.072C512,455.876,505.896,461.98,498.432,461.98z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFA624"
    },
    cx: 74.416,
    cy: 389.372,
    r: 16.792
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#09BA98"
    },
    cx: 121.792,
    cy: 389.372,
    r: 16.792
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#05C3D6"
    },
    cx: 169.12,
    cy: 389.372,
    r: 16.792
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 383.664,
    y: 119.428,
    width: 12.192,
    height: 197.336
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 415.744,
    y: 461.98,
    style: {
      fill: "#999999"
    },
    width: 63.2,
    height: 8.152
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.056,
    y: 461.98,
    style: {
      fill: "#999999"
    },
    width: 63.2,
    height: 8.152
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#05C3D6"
    },
    cx: 389.76,
    cy: 130.14,
    r: 22.064
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#05C3D6"
    },
    d: "M389.76,190.244c-33.096,0-60.008-26.968-60.008-60.104c0-33.128,26.92-60.096,60.008-60.096 s60.024,26.968,60.024,60.096C449.784,163.276,422.856,190.244,389.76,190.244z M389.76,82.228 c-26.368,0-47.824,21.488-47.824,47.904s21.456,47.92,47.824,47.92c26.384,0,47.832-21.504,47.832-47.92 S416.136,82.228,389.76,82.228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#05C3D6"
    },
    d: "M389.76,234.42c-57.416,0-104.12-46.784-104.12-104.288S332.344,25.86,389.76,25.86 s104.128,46.776,104.128,104.272S447.176,234.42,389.76,234.42z M389.76,38.052c-50.688,0-91.928,41.312-91.928,92.08 c0,50.784,41.24,92.096,91.928,92.096s91.944-41.312,91.944-92.096C481.696,79.356,440.448,38.052,389.76,38.052z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.25,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M0,330.332V392.1h512v-61.768 c0-7.464-6.104-13.568-13.568-13.568H13.568C6.104,316.764,0,322.868,0,330.332z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.ce3ec1b3e8655bfa6acd55e07f9695f6.svg";
export { ForwardRef as ReactComponent };